const NOCO_URL = (process.env.REACT_APP_NOCO_URL || process.env.NOCO_URL || 'https://db.misha.live').replace(/\/$/, '');
const NOCO_TOKEN = process.env.REACT_APP_NOCO_TOKEN || process.env.NOCO_TOKEN || '';

const TABLES = {
  videos: 'mumomchayk4fmeh',
  videoCategories: 'm9deioneoj1ah3j',
  venues: 'moaeinb06gjef42',
  books: 'mv9enc6bu7n2fn5',
  photos: 'milj3noe4jwk6fl',
  ui: 'mqmuo98u7g5adn3',
};

const TABLE_FIELDS = {
  videos: [
    'Id', 'ncRecordId', 'id_1', 'youtubeId', 'language', 'active',
    'start_time', 'end_time', 'order', 'date', 'tags', 'categories',
    'venue_id', 'venue_title', 'venue_sub_title',
  ],
  videoCategories: [
    'Id', 'ncRecordId', 'id_1', 'title-en', 'title-ru', 'active', 'order',
  ],
  venues: [
    'Id', 'ncRecordId', 'id_1', 'title', 'sub_title', 'active',
  ],
  books: [
    'Id', 'ncRecordId', 'id_1', 'active', 'order',
    'title-en', 'title-ru', 'title_sub-en',
    'link-en', 'link-ru', 'description-en', 'description-ru',
    'image-en', 'image-ru',
  ],
  photos: [
    'Id', 'ncRecordId', 'id_1', 'active', 'order', 'title', 'image',
  ],
};

function getToken() {
  if (!NOCO_TOKEN) {
    throw new Error('Missing NocoDB token (REACT_APP_NOCO_TOKEN)');
  }
  return NOCO_TOKEN;
}

export function asList(value) {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) {
    return value.flatMap(asList).filter((item) => item != null && item !== '');
  }
  if (typeof value === 'string') {
    return value.split(',').map((item) => item.trim()).filter(Boolean);
  }
  return [value];
}

export function isActive(value) {
  return value === true || value === 1 || value === '1';
}

export function fileUrl(file) {
  if (!file) return '';
  if (typeof file === 'string') {
    return /^https?:\/\//.test(file) ? file : `${NOCO_URL}/${file.replace(/^\//, '')}`;
  }
  const path = file.url || file.signedUrl || file.path || file.signedPath;
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  return `${NOCO_URL}/${String(path).replace(/^\//, '')}`;
}

export function normalizeAttachment(files) {
  const file = Array.isArray(files) ? files[0] : files;
  if (!file) {
    return { url: '', width: 0, height: 0, thumbnails: { large: { url: '', width: 0, height: 0 } } };
  }
  const url = fileUrl(file);
  const large = { url, width: file.width, height: file.height };
  return {
    url,
    width: file.width,
    height: file.height,
    filename: file.title,
    thumbnails: { large, small: large },
  };
}

export async function fetchRecords(tableName, { fields } = {}) {
  const tableId = TABLES[tableName] || tableName;
  const selectedFields = fields || TABLE_FIELDS[tableName];
  const records = [];
  let offset = 0;
  const limit = 200;

  while (true) {
    const params = new URLSearchParams({
      offset: String(offset),
      limit: String(limit),
    });
    if (selectedFields && selectedFields.length) {
      params.set('fields', selectedFields.join(','));
    }

    const response = await fetch(`${NOCO_URL}/api/v2/tables/${tableId}/records?${params}`, {
      method: 'GET',
      headers: { 'xc-token': getToken() },
    });

    if (!response.ok) {
      const body = await response.text();
      throw new Error(`NocoDB ${tableName} ${response.status}: ${body}`);
    }

    const data = await response.json();
    records.push(...(data.list || []));

    if (data.pageInfo?.isLastPage) break;
    offset += data.pageInfo?.pageSize || limit;
  }

  return records;
}

export function mapVideo(record) {
  return {
    _id: record.ncRecordId || String(record.Id),
    id: record.id_1,
    order: record.order || 0,
    youtubeId: record.youtubeId || '',
    language: asList(record.language).length ? asList(record.language) : ['en', 'ru'],
    title: record.id_1,
    start: record.start || 0,
    startTime: record.start_time || 0,
    endTime: record.end_time || null,
    categories: asList(record.categories),
    tags: asList(record.tags),
    venue_id: asList(record.venue_id),
    venue_title: asList(record.venue_title)[0] || '',
    venue_sub_title: asList(record.venue_sub_title)[0] || '',
    date: record.date || '',
  };
}

export function mapVideoCategory(record) {
  return {
    _id: record.ncRecordId || String(record.Id),
    id: record.id_1,
    order: record.order || 0,
    'title-en': record['title-en'],
    'title-ru': record['title-ru'],
    videos: [],
  };
}

export function mapVenue(record) {
  return {
    _id: record.ncRecordId || String(record.Id),
    id: record.id_1,
    title: record.title,
    sub_title: record.sub_title,
    videos: [],
    videoLanguages: [],
  };
}

export function mapBook(record) {
  return {
    _id: record.ncRecordId || String(record.Id),
    id: record.id_1,
    order: record.order || 0,
    'title-en': record['title-en'],
    'title-ru': record['title-ru'],
    'title_sub-en': record['title_sub-en'],
    'title_sub-ru': record['title_sub-ru'],
    'link-en': record['link-en'] || '',
    'link-ru': record['link-ru'] || '',
    'image-en': normalizeAttachment(record['image-en']),
    'image-ru': normalizeAttachment(record['image-ru']),
    'description-en': record['description-en'] || '',
    'description-ru': record['description-ru'] || '',
  };
}

export function mapPhoto(record) {
  const image = Array.isArray(record.image) ? record.image[0] : record.image;
  return {
    _id: record.ncRecordId || String(record.Id),
    id: record.id_1 || record.title,
    order: record.order || 0,
    image: fileUrl(image),
    width: image && image.width,
    height: image && image.height,
  };
}

export function applyLanguage(collections, language) {
  const videos = collections.videos
    .filter((video) => video.language.includes(language))
    .sort((a, b) => (b.order || 0) - (a.order || 0));

  const videoCategories = collections.videoCategories
    .map((category) => ({
      ...category,
      title: category[`title-${language}`] || category['title-en'] || category['title-ru'],
      videos: videos.filter((video) => video.categories.includes(category.id)).map((video) => video._id),
    }))
    .filter((category) => category.videos.length || category.id === 'audio')
    .sort((a, b) => (b.order || 0) - (a.order || 0));

  const venues = collections.venues
    .map((venue) => {
      const venueVideos = videos.filter((video) => video.venue_id.includes(venue.id));
      return {
        ...venue,
        videos: venueVideos.map((video) => video._id),
        videoLanguages: [...new Set(venueVideos.flatMap((video) => video.language))],
      };
    })
    .filter((venue) => venue.videos.length)
    .sort((a, b) => b.videos.length - a.videos.length);

  const books = collections.books
    .map((book) => ({
      ...book,
      title: book[`title-${language}`],
      title_sub: book[`title_sub-${language}`] || book['title_sub-en'],
      link: book[`link-${language}`] || '',
      image: book[`image-${language}`],
      description: book[`description-${language}`] || '',
    }))
    .sort((a, b) => (b.order || 0) - (a.order || 0));

  return { videos, videoCategories, venues, books };
}

export async function loadNocoCollections() {
  const [videoRecords, categoryRecords, venueRecords, bookRecords] = await Promise.all([
    fetchRecords('videos'),
    fetchRecords('videoCategories'),
    fetchRecords('venues'),
    fetchRecords('books'),
  ]);

  return {
    videos: videoRecords.filter((record) => isActive(record.active) && record.youtubeId).map(mapVideo),
    videoCategories: categoryRecords.filter((record) => isActive(record.active)).map(mapVideoCategory),
    venues: venueRecords.filter((record) => isActive(record.active)).map(mapVenue),
    books: bookRecords.filter((record) => isActive(record.active)).map(mapBook),
  };
}

export { NOCO_URL, TABLES };
